import Swiper, { Autoplay, Navigation } from 'swiper';
import { swiperObserver } from '../utils/swiper.utils.js';

let gallerySwiperWr = document.querySelectorAll('.gallery-swiper-wr');
gallerySwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
    let wrapper = swiperEl.querySelector('.swiper-wrapper');
    let swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Navigation],
      observer: true, //needs to calculate swiper size
      observeParents: true, //needs to calculate swiper size
      spaceBetween: 20,
      slidesPerView: 1,
      threshold: 10,
      speed: 800,

      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      breakpoints: {
        451: {
          spaceBetween: 20,
          slidesPerView: 1.5,
        },
        640: {
          spaceBetween: 20,
          slidesPerView: 2,
        },
        993: {
          spaceBetween: 20,
          slidesPerView: 3,
        },
        1201: {
          spaceBetween: 30,
          slidesPerView: 3,
        },
        1279: {
          spaceBetween: 24,
          slidesPerView: 4,
        },
      },
      autoplay: false,
      on: {
        afterInit: function () {
          wrapper.scrollWidth >= wrapper.clientWidth
            ? wrapper.classList.remove('justify-center')
            : wrapper.classList.add('justify-center');
        },

        resize: function () {
          wrapper.scrollWidth >= wrapper.clientWidth
            ? wrapper.classList.remove('justify-center')
            : wrapper.classList.add('justify-center');
        }
      },
    });
  }
});
